import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { raceResultsAPI } from '@/services/raceResultsApi';
import { queryKeys } from './queryKeys';

export function useResults(raceId?: any, params?: any) {
  return useQuery({
    queryKey: queryKeys.results.list(raceId, params),
    queryFn: () => raceResultsAPI.getResults(raceId, params),
    enabled: !!raceId,
  });
}

export function useTeamResults(raceId?: any, params?: any) {
  return useQuery({
    queryKey: queryKeys.results.teams(raceId, params),
    queryFn: () => raceResultsAPI.getTeamResults(raceId, params),
    enabled: !!raceId,
  });
}

export function useResultsSummary(raceId?: any) {
  return useQuery({
    queryKey: queryKeys.results.summary(raceId),
    queryFn: () => raceResultsAPI.getResultsSummary(raceId),
    enabled: !!raceId,
  });
}

export function usePublicResults(raceId?: any, params?: any) {
  return useQuery({
    queryKey: ['public-results', raceId, params],
    queryFn: () => raceResultsAPI.getPublicResults(raceId, params),
    enabled: !!raceId,
  });
}

export function usePublicTeamResults(raceId?: any, params?: any) {
  return useQuery({
    queryKey: ['public-team-results', raceId, params],
    queryFn: () => raceResultsAPI.getPublicTeamResults(raceId, params),
    enabled: !!raceId,
  });
}

export function usePublicResultsSummary(raceId?: any) {
  return useQuery({
    queryKey: ['public-results-summary', raceId],
    queryFn: () => raceResultsAPI.getPublicResultsSummary(raceId),
    enabled: !!raceId,
  });
}

export function useImportResults(raceId?: any) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (jsonString: any) => raceResultsAPI.importResults(raceId, jsonString),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: queryKeys.results.list(raceId) });
      qc.invalidateQueries({ queryKey: queryKeys.results.teams(raceId) });
      qc.invalidateQueries({ queryKey: queryKeys.results.summary(raceId) });
    },
  });
}

export function useDeleteAllResults(raceId?: any) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: () => raceResultsAPI.deleteAllResults(raceId),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: queryKeys.results.list(raceId) });
      qc.invalidateQueries({ queryKey: queryKeys.results.teams(raceId) });
      qc.invalidateQueries({ queryKey: queryKeys.results.summary(raceId) });
    },
  });
}

export function useDeleteResult(raceId?: any) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id: any) => raceResultsAPI.deleteResult(raceId, id),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: queryKeys.results.list(raceId) });
      qc.invalidateQueries({ queryKey: queryKeys.results.summary(raceId) });
    },
  });
}
